<template>
  <h1 class="MissionHeaderBlock primary--text mb-3">
    <slot></slot>
  </h1>
</template>

<script>
  export default {
    props: {}
  }
</script>

<style lang="scss"
       type="text/scss">
  .MissionHeaderBlock {
    font-size: 30px;
    font-weight: 900;
    line-height: 30px;
  }
</style>
